import _ from "lodash";
import { FETCH_STEPS, UPDATE_STEPS } from "../actions";

export default function(state = {}, action) {
    switch (action.type) {
        case FETCH_STEPS:
            return action.payload;
        case UPDATE_STEPS:
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/steps_reducer.js